import { generateEntityId } from '@/stores/_shared/entityStoreHelpers';

interface BaseServiceOptions {
  storagePrefix?: string;
}

export abstract class BaseService<T> {
  protected constructor(private readonly options: BaseServiceOptions = {}) {}

  protected now(): string {
    return new Date().toISOString();
  }

  protected createId(prefix: string): string {
    return generateEntityId(prefix);
  }

  protected storageKey(suffix: string): string {
    const prefix = this.options.storagePrefix ?? this.constructor.name;
    return `${prefix}:${suffix}`;
  }

  protected debug(message: string, details?: unknown): void {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug(`[${this.constructor.name}] ${message}`, details);
    }
  }
}

